import React, { useEffect } from "react";
import moment from "moment";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { NotificationManager } from "react-notifications";
import { GestionAlmacenApi } from "../api/GestionAlmacenApi";

export const useAnalisisDRC = ({ almacenInventarioId }) => {
    const [analisisActual, setAnalisisActual] = React.useState(null);
    const [kgHumedosInput, setKgHumedosInput] = React.useState("");
    const [nuevoAnalisis, setNuevoAnalisis] = React.useState(false);
    const [editarSolicitud, setEditarSolicitud] = React.useState(false);

    const {
        getAnalisisDRC,
        solicitarAnalisisDRC,
        actualizarAnalisisDRC,
        resolicitarAnalisisDRC,
        cargando,
    } = GestionAlmacenApi();

    const GetAnalisisDRC = async () => {
        try {
            const response = await getAnalisisDRC(almacenInventarioId);
            if (response) {
                if (response.exists) setAnalisisActual(response.analisis);
                else setAnalisisActual(null);
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el análisis DRC",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setAnalisisActual(null);
        }
    };

    useEffect(() => {
        GetAnalisisDRC();
    }, []);

    const kgHumedosValidos = () => {
        if (kgHumedosInput > 0) return true;

        NotificationManager.error(
            "Los kilos húmedos deben ser mayores a 0.",
            "Error",
            3000,
        );
        return false;
    };

    const SolicitarAnalisis = async () => {
        if (!kgHumedosValidos()) return;

        try {
            const body = {
                kg_humedos: parseFloat(kgHumedosInput),
            };

            await solicitarAnalisisDRC(almacenInventarioId, body);

            setKgHumedosInput("");
            await GetAnalisisDRC();
            setNuevoAnalisis(false);
            setEditarSolicitud(false);
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al solicitar análisis DRC",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const SolicitarNuevoAnalisis = async () => {
        if (!kgHumedosValidos()) return;

        try {
            const body = {
                kg_humedos: parseFloat(kgHumedosInput),
            };

            await resolicitarAnalisisDRC(almacenInventarioId, body);
            setKgHumedosInput("");
            await GetAnalisisDRC();
            setNuevoAnalisis(false);
            setEditarSolicitud(false);
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al solicitar nuevo análisis DRC",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EditarSolicitudPendiente = async () => {
        if (!kgHumedosValidos()) return;

        try {
            const body = {
                kg_humedos: parseFloat(kgHumedosInput),
                fecha_solicitud_analisis: moment().format(
                    "YYYY-MM-DD HH:mm:ss",
                ),
            };

            await actualizarAnalisisDRC(analisisActual.id, body);

            setKgHumedosInput("");
            await GetAnalisisDRC();
            setNuevoAnalisis(false);
            setEditarSolicitud(false);
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al editar solicitud de análisis DRC",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return {
        analisisActual,
        kgHumedosInput,
        setKgHumedosInput,
        SolicitarAnalisis,
        SolicitarNuevoAnalisis,
        nuevoAnalisis,
        setNuevoAnalisis,

        EditarSolicitudPendiente,
        editarSolicitud,
        setEditarSolicitud,
        cargando,
    };
};
